<si-landing-page
  heading="Commissioning Tool"
  subheading="Building X"
  copyright="© Siemens 2021-2023"
  [subtitle]="'APP.CLAIM' | translate"
  [links]="[
    { title: 'Corporate Information', href: 'http://www.siemens.com/corporate-information' },
    { title: 'Privacy Notice', href: 'http://www.siemens.com/privacy-notice' },
    { title: 'Terms of Use', href: 'http://www.siemens.com/terms-of-use' }
  ]"
  [availableLanguages]="[
    { value: 'en', name: 'English' },
    { value: 'de', name: 'Deutsch' },
    { value: 'fr', name: 'Français' }
  ]"
>
  <button
    type="button"
    class="btn btn-primary w-100"
    [disabled]="loginError"
    (click)="login()"
  >{{ "LOGIN" | translate }}
  </button>


  <br />
  <div class="si-body-2">
    Don't have an account? <a routerLink="./" class="si-title-2 ps-6">Register now</a>
  </div>
  <div class="si-title-2 text-secondary mt-8"> Productive Data </div>
  <div class="si-body-2 text-secondary mt-4">
    You are about to connect to productive data. Please note that changes will take effect
    immediately
  </div>
</si-landing-page>
